/* global document */

import React, { useCallback, useEffect, useRef } from 'react'; // eslint-disable-line
import { useContext } from 'react';
import AppContext from './context/AppContext';
import { number, oneOfType, shape, string } from 'prop-types';

/**
 * Initialize the Answerbase Product Widget using the product data
 * @param {object} data - The product data to display the widget for
 */
export default function AnswerBaseProductWidget(data) {
    const {
        productId,
        productSku,
        productTitle,
        productPrice,
        productUrl,
        productDescription,
        productImageUrl,
    } = data;
    const { appContext } = useContext(AppContext);
    const { answerBaseServiceUrl } = appContext.config;
    const containerRef = useCallback((node) => {
        if (!node || !answerBaseServiceUrl) {
            return;
        }
        // eslint-disable-next-line no-undef
        const fragment = new DocumentFragment();
        const script = document.createElement('script');
        const widgetUrl = new URL(
            '/javascript/widget/full-featured-widget.min.js', answerBaseServiceUrl).toString();
        script.src = widgetUrl;
        script.type = 'text/javascript';
        script.defer = true;
        // Assign product data
        script.dataset['external-id'] = productId;
        script.dataset['product-sku'] = productSku;
        script.dataset['product-title'] = productTitle;
        script.dataset['product-price'] = productPrice;
        script.dataset['product-URL'] = productUrl;
        script.dataset['product-description'] = productDescription;
        script.dataset['product-image-url'] = productImageUrl;
        // Add the script to the view
        fragment.appendChild(script);
        node.appendChild(fragment);
    }, []);
    return (<div
        ref={containerRef}></div>);
}

AnswerBaseProductWidget.propTypes = {
    data: shape({
        productId: oneOfType([number, string]),
        productSku: string,
        productTitle: string,
        productPrice: oneOfType([number, string]),
        productUrl: string,
        productDescription: string,
        productImageUrl: string,
    }),
};